import React from "react";
import { ProductType } from "swan-public-api-client";
import { FormattedMessage } from "react-intl";

interface Props {
  value: ProductType
}

export class FormattedProductType extends React.PureComponent<Props> {
  public render() {
    switch (this.props.value) {
      case ProductType.SpreadBet:
        return (<FormattedMessage id="productType.spreadBet" />);
      case ProductType.CFD:
        return (<FormattedMessage id="productType.cfd" />);
      case ProductType.SpotFX:
        return (<FormattedMessage id="productType.spotFx" />);
      default:
        throw new Error(`Unknown ProductType "${this.props.value}"`);
    }
  }
}
